import { Sidebar } from "@repo/ui/ui/sidebar";

import { AppSidebarContent } from "./content";
import { AppSidebarFooter } from "./sidebar-footer";
import { AppSidebarHeader } from "./sidebar-header";

export const AppSidebar = () => {
  return (
    <Sidebar
      name="left"
      variant="inset"
      collapsible="offcanvas"
      className="top-(--header-height) h-[calc(100svh-var(--header-height))] p-0"
    >
      <AppSidebarHeader />
      <AppSidebarContent />
      <AppSidebarFooter />
    </Sidebar>
  );
};
